import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { loadingTrue, loadingFalse } from "../../Reducer/loaderSlice";
import Handler from "../../Helpers/Handler";
import Pagination from "../../Helpers/Pagination";
import dayjs from "dayjs";
import Select from "react-select";
import { LocalizationProvider, DatePicker } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { Modal, ModalBody, Button } from "reactstrap";
import { toast } from "react-toastify";
import { useNavigate } from "react-router-dom";
import { getCookie } from "../../Helpers/Utils";
import PaymentModal from "./Payment";
import axios from "axios";

const InvoiceList = () => {
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const userRole = getCookie("role") || "admin";

    const [data, setData] = useState([]);
    const [page, setPage] = useState(1);
    const [total, setTotal] = useState(0);

    // Filters
    const [search, setSearch] = useState(""); 
    const [status, setStatus] = useState(null);
    const [fromDate, setFromDate] = useState(null);
    const [toDate, setToDate] = useState(null);
    // ⭐ New filter state for Customer based on API
    const [filterCustomer, setFilterCustomer] = useState(null); 

    const [payModal, setPayModal] = useState(false);
    const [selectedInvoiceForPay, setSelectedInvoiceForPay] = useState(null);

    const [periodModal, setPeriodModal] = useState(false);
    const [customers, setCustomers] = useState([]);
    const [selectedCustomer, setSelectedCustomer] = useState(null);
    const [genFromDate, setGenFromDate] = useState(null);
    const [genToDate, setGenToDate] = useState(null);

    const limit = 20;

    const statusOptions = [
        { value: "", label: "All Status" },
        { value: "issued", label: "Issued" },
        { value: "paid", label: "Paid" },
        { value: "partially_paid", label: "Partially Paid" },
        { value: "cancelled", label: "Cancelled" }
    ];

    const loadInvoices = async () => {
        dispatch(loadingTrue());
        // ⭐ API base panni 'q' (Global Search) and 'customer_id' add pannirukaen
        let url = `/invoice/list.php?page=${page}&limit=${limit}`;
        
        if (search) url += `&q=${encodeURIComponent(search)}`; 
        if (status?.value) url += `&status=${status.value}`;
        if (filterCustomer?.value) url += `&customer_id=${filterCustomer.value}`;
        if (fromDate) url += `&date_from=${fromDate.format("YYYY-MM-DD")}`;
        if (toDate) url += `&date_to=${toDate.format("YYYY-MM-DD")}`;

        const res = await Handler({ method: "get", url });
        
        // API status: true use pannurathala if condition update
        if (res?.status || res?.success) {
            setData(res?.data || []);
            setTotal(res?.pagination?.total_rows || 0);
        }
        dispatch(loadingFalse());
    };

    const loadCustomers = async () => {
        const res = await Handler({ method: "get", url: "/customer/list.php?status=active" });
        if (res?.success || res?.status) {
            setCustomers(res.data.map(c => ({ value: c.id, label: c.company_name })));
        }
    };

    const handleOpenPeriodModal = () => {
        loadCustomers();
        setPeriodModal(true);
    };

    const handleAddPayment = (row) => {
        setSelectedInvoiceForPay({
            id: row.invoice_id,
            invoice_number: row.invoice_number,
            total_amount: row.total_amount,
            paid_amount: row.total_paid,
            customer_id: row.customer_id
        });
        setPayModal(true);
    };

    const handleInvoicePrint = async (quotationId, invoiceId) => {
        const token = getCookie("token");
        dispatch(loadingTrue());

        try {
            const response = await axios({
                method: "post",
                // url: `${process.env.REACT_APP_API_URL || "http://localhost/vehicle"}/invoice/manual_generate.php`,
                url: `${process.env.REACT_APP_API_URL || "https://sfs.software.dizoratbd.com/vehicle_pos"}/invoice/manual_generate.php`,
                // url: `${process.env.REACT_APP_API_URL || "http://localhost/vehicle_pos"}/invoice/manual_generate.php`,
                data: { quotation_id: quotationId, invoice_id: invoiceId },
                headers: {
                    "Authorization": `Bearer ${token}`
                },
                responseType: 'blob'
            });

            const file = new Blob([response.data], { type: 'application/pdf' });
            const fileURL = URL.createObjectURL(file);
            const printWindow = window.open(fileURL, '_blank');

            if (printWindow) {
                printWindow.onload = () => {
                    setTimeout(() => {
                        printWindow.focus();
                        printWindow.print();
                    }, 500);
                };
            } else {
                toast.error("Pop-up blocked! Please allow pop-ups.");
            }

        } catch (err) {
            console.error("Print Error:", err);
            toast.error("Error in generating PDF. Check console.");
        } finally {
            dispatch(loadingFalse());
        }
    };

    const handleGeneratePeriodInvoice = async () => {
        if (!selectedCustomer || !genFromDate || !genToDate) {
            toast.warning("Please fill all fields!");
            return;
        }

        const token = getCookie("token");
        dispatch(loadingTrue());

        try {
            // const response = await fetch(`${process.env.REACT_APP_API_URL || "http://localhost/vehicle_pos"}/invoice/generate_by_period.php`, {
            const response = await fetch(`${process.env.REACT_APP_API_URL || "https://sfs.software.dizoratbd.com/vehicle_pos"}/invoice/generate_by_period.php`, {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                    "Authorization": `Bearer ${token}`
                },
                body: JSON.stringify({
                    customer_id: selectedCustomer.value,
                    date_from: genFromDate.format("YYYY-MM-DD"),
                    date_to: genToDate.format("YYYY-MM-DD")
                })
            });

            const contentType = response.headers.get("content-type");
            if (!response.ok || !contentType?.includes("application/pdf")) {
                const errData = await response.json();
                throw new Error(errData.message || "Server Error: Failed to generate PDF");
            }

            const blob = await response.blob();
            if (blob.size === 0) throw new Error("Received empty PDF blob");

            const pdfBlob = new Blob([blob], { type: 'application/pdf' });
            const url = window.URL.createObjectURL(pdfBlob);
            const printWindow = window.open(url, '_blank');

            if (printWindow) {
                toast.success("Invoice Preview Ready!");
                setPeriodModal(false);
                loadInvoices();

                const checkLoad = setInterval(() => {
                    if (printWindow.document.readyState === 'complete') {
                        clearInterval(checkLoad);
                        printWindow.focus();
                        setTimeout(() => {
                            printWindow.print();
                        }, 1000);
                    }
                }, 500);

            } else {
                const link = document.createElement('a');
                link.href = url;
                link.download = `Period_Invoice_${selectedCustomer.label}.pdf`;
                document.body.appendChild(link);
                link.click();
                link.remove();
                toast.info("Popup blocked! Invoice downloaded.");
                setPeriodModal(false);
            }

        } catch (error) {
            console.error("PDF Error:", error);
            toast.error(error.message);
        } finally {
            dispatch(loadingFalse());
        }
    };

    useEffect(() => { loadInvoices(); }, [page, status]);

    // Added this to load customer list for the filter on mount
    useEffect(() => { loadCustomers(); }, []);

    const handleSearch = () => {
        setPage(1);
        loadInvoices();
    };

    const resetFilters = () => {
        setSearch(""); 
        setStatus(null); 
        setFromDate(null); 
        setToDate(null); 
        setFilterCustomer(null);
        setPage(1);
    };

    return (
        <div className="page-card">
            <div className="page-header flex-wrap gap-3">
                <div className="d-flex align-items-center gap-3">
                    <h4 className="mb-0">All Invoices</h4>
                    <button className="btn btn-sm btn-success px-3" onClick={handleOpenPeriodModal}>
                        <i className="bi bi-plus-circle me-1"></i> Generate Period Invoice
                    </button>
                </div>

                <LocalizationProvider dateAdapter={AdapterDayjs}>
                    <div className="d-flex align-items-center gap-2 flex-nowrap overflow-auto pb-2">
                        {/* ⭐ Global Search Input (maps to 'q') */}
                        <input type="text" placeholder="Search (Inv #, Company, Vessel...)" className="form-control" style={{ minWidth: 200 }} value={search} onChange={e => setSearch(e.target.value)} />
                        
                        {/* ⭐ Customer filter dropdown based on API customer_id */}
                        <div style={{ minWidth: 200 }}>
                            <Select 
                                options={customers} 
                                value={filterCustomer} 
                                onChange={(val) => setFilterCustomer(val)} 
                                placeholder="Filter By Customer" 
                                isClearable
                            />
                        </div>

                        <div style={{ minWidth: 150 }}><Select options={statusOptions} value={status} onChange={(val) => setStatus(val)} placeholder="Status" /></div>
                        <div style={{ minWidth: 160 }}><DatePicker label="From" value={fromDate} onChange={(val) => setFromDate(val)} slotProps={{ textField: { size: "small" } }} /></div>
                        <div style={{ minWidth: 160 }}><DatePicker label="To" value={toDate} onChange={(val) => setToDate(val)} slotProps={{ textField: { size: "small" } }} /></div>
                        
                        <button className="btn btn-primary px-3" onClick={handleSearch}>Search</button>
                        <button className="btn btn-secondary px-3" onClick={resetFilters}>Reset</button>
                    </div>
                </LocalizationProvider>
            </div>

            <div className="table-wrap">
                <table className="table modern-table">
                    <thead>
                        <tr>
                            <th>Invoice #</th>
                            <th>Date</th>
                            <th>Customer</th>
                            <th>Vessel Name</th>
                            <th>Total Amount</th>
                            <th>Paid</th>
                            <th>Balance</th>
                            <th>Status</th>
                            <th className="text-center">Action</th>
                        </tr>
                    </thead>
                    <tbody>
                        {data.length === 0 ? (
                            <tr><td colSpan="9" className="text-center">No invoices found</td></tr>
                        ) : data?.map((row) => (
                            <tr key={row.invoice_id}>
                                <td className="fw-semibold text-primary">{row.invoice_number}</td>
                                <td>{dayjs(row.issued_date).format("DD-MM-YYYY")}</td>
                                <td>{row.company_name}</td>
                                <td>{row.vessel_name || "-"}</td>
                                <td>SGD {parseFloat(row.total_amount).toFixed(2)}</td>
                                <td className="text-success">{parseFloat(row.total_paid).toFixed(2)}</td>
                                <td className="text-danger fw-bold">{parseFloat(row.remaining_balance).toFixed(2)}</td>
                                <td><span className={`status-badge ${row.status}`}>{row.status}</span></td>
                                <td className="text-center">
                                    <div className="d-flex gap-2 justify-content-center">
                                        {userRole === 'admin' && parseFloat(row.remaining_balance) > 0 && (
                                            <button
                                                className="btn btn-sm btn-light border rounded-circle text-success"
                                                title="Add Payment"
                                                onClick={() => handleAddPayment(row)}
                                            >
                                                <i className="bi bi-cash-stack"></i>
                                            </button>
                                        )}
                                        <button
                                            className="btn btn-sm btn-light border rounded-circle text-danger"
                                            title="Print Invoice"
                                            onClick={() => handleInvoicePrint(row.quotation_id, row.invoice_id)}
                                        >
                                            <i className="bi bi-printer"></i>
                                        </button>
                                        <button
                                            className="btn btn-sm btn-light border rounded-circle text-primary"
                                            title="View Details"
                                            onClick={() => navigate(`/invoice/view/${row.invoice_id}`)}
                                        >
                                            <i className="bi bi-eye"></i>
                                        </button>
                                        {userRole === 'admin' && (
                                            <button
                                                className="btn btn-sm btn-light border rounded-circle text-primary"
                                                title="Edit Invoice"
                                                onClick={() => navigate(`/invoice/edit/${row.invoice_id}`)}
                                            >
                                                <i className="bi bi-pencil"></i>
                                            </button>
                                        )}
                                    </div>
                                </td>
                            </tr>
                        ))}
                    </tbody>
                </table>
            </div>

            <Pagination page={page} total={total} limit={limit} onPrev={() => setPage(p => Math.max(1, p - 1))} onNext={() => setPage(p => p + 1)} />

            {selectedInvoiceForPay && (
                <PaymentModal
                    isOpen={payModal}
                    toggle={() => setPayModal(!payModal)}
                    invoiceData={selectedInvoiceForPay}
                    onSuccess={() => {
                        toast.success("Payment updated!");
                        loadInvoices();
                    }}
                />
            )}

            <Modal isOpen={periodModal} toggle={() => setPeriodModal(false)} centered>
                <div className="p-4">
                    <h5 className="mb-4">Generate Period Invoice</h5>
                    <div className="mb-3">
                        <label className="form-label small fw-bold">Select Customer</label>
                        <Select options={customers} onChange={setSelectedCustomer} placeholder="Search Customer..." />
                    </div>
                    <LocalizationProvider dateAdapter={AdapterDayjs}>
                        <div className="row g-2 mb-4">
                            <div className="col-6">
                                <DatePicker label="Start Date" value={genFromDate} onChange={(val) => setGenFromDate(val)} slotProps={{ textField: { size: "small", fullWidth: true } }} />
                            </div>
                            <div className="col-6">
                                <DatePicker label="End Date" value={genToDate} onChange={(val) => setGenToDate(val)} slotProps={{ textField: { size: "small", fullWidth: true } }} />
                            </div>
                        </div>
                    </LocalizationProvider>
                    <div className="d-flex gap-2 mt-2">
                        <Button color="light" className="flex-grow-1" onClick={() => setPeriodModal(false)}>Cancel</Button>
                        <Button color="success" className="flex-grow-1" onClick={handleGeneratePeriodInvoice}>Generate & Download</Button>
                    </div>
                </div>
            </Modal>
        </div>
    );
};

export default InvoiceList;